import { realm } from '@bt-react/constants'
import get from 'lodash/get'

export const isChannelInAnonymousRealm = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  return !!channelData.features.find(({ name, enabled, value }) => name === 'allowedRealms' && enabled === true && value.split(',').includes(realm.ANONYMOUS))

}
